import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LocalazyBackend from './localazyBackend';
import translations from './locales';

const fallback = 'en';

const supportedLanguages = ['en', 'es'];

const isDevelopment = process.env.NODE_ENV === 'development';

let backendLocalazyInstance = null;

if (isDevelopment) {
    // if we are in development, we use the Localazy API instead of the CDN
    backendLocalazyInstance = new LocalazyBackend(i18next.services);
}

const i18nConfig = {
    lng: fallback,
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: false,
    },
};

if (isDevelopment && backendLocalazyInstance) {
    i18next
        .use(backendLocalazyInstance)
        .use(initReactI18next)
        .init({
            ...i18nConfig,
            fallbackLng: supportedLanguages,
        });
} else {
    i18next.use(initReactI18next).init({
        ...i18nConfig,
        resources: translations,
    });
}

export default i18next;
